import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationManager } from '@managers/notification.manager';
import { SplitDocService } from '@services/split-doc.service';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { distinctUntilChanged, of, switchMap, take, takeUntil, tap } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-split-doc-panel',
    templateUrl: './split-doc-panel.component.html',
    styleUrls: ['./split-doc-panel.component.scss'],
    standalone: false
})
export class SplitDocPanelComponent extends BaseComponent implements OnInit {
	public currentDocument$ = this.docViewerStore.currentDocument$;
	public splitTaskType: 'split' | 'remove';
	public splitString: string = '';
	public splitStringControl: FormControl;

	constructor(
		public docViewerStore: DocViewerStore,
		private notificationManager: NotificationManager,
		private splitDocService: SplitDocService,
		private route: ActivatedRoute,
		private router: Router
	) {
		super();
		this.currentDocument$.pipe(
			distinctUntilChanged((a, b) => a.docId === b.docId),
			tap(() => {
				if (this.splitStringControl) {
					this.splitString = '';
					this.splitStringControl.setValue(this.splitString)

				}
				else {
					this.splitStringControl = new FormControl(this.splitString)
					this.splitStringControl.setValidators([Validators.required,
					Validators.maxLength(2048)]);
				}
				this.splitStringControl.updateValueAndValidity();
				this.splitStringControl.markAsPristine();
			}),
			takeUntil(this.destroy$)
		).subscribe();
	}

	public ngOnInit(): void {
		this.splitStringControl.valueChanges.pipe(
			takeUntil(this.destroy$)
		).subscribe((value) => {
			this.splitString = value;
		});
	}

	public splitDocInstructionsKeyPress(event: any): boolean {
		return /[0-9, -]/.test(event.key);
	}

	public splitDoc(taskType: 'split' | 'remove'): void {
		this.splitTaskType = taskType;
		this.currentDocument$.pipe(
			take(1),
			switchMap((current) => {
				if (current.status.isRedacted) {
					this.notificationManager.displaySnackBarMessage({
						message: 'Redacted documents cannot be split',
						type: 'warn'
					});
					return of(null);
				}

				return this.splitDocService.create(current.docId, this.splitTaskType, this.splitString
				).pipe(tap(() => {
					this.notificationManager.displaySnackBarMessage({
						message: this.splitTaskType === 'split' ? 'Extract Task Queued' : 'Remove Task Queued'
					});
				}));
			})
		).subscribe(() => {
			this.router.navigate(["."], {
				queryParams: {
					action: null
				},
				queryParamsHandling: "merge",
				relativeTo: this.route
			});
		});
	}
}
